import Clarity from '@microsoft/clarity';

import { CLARITY_PROJECT_ID, ENV } from '@/env';

if (ENV === 'production') {
  Clarity.init(CLARITY_PROJECT_ID);
}
